<template>
    <div class="login-container">
        <login-component></login-component>
    </div>
</template>

<script>
    import LoginComponent from "@/components/auth/LoginComponent";
    export default {
        name: "Login",
        components: {
            LoginComponent
        },
        mixins: [  ],
        data(){
            return{

            }
        },

        created(){

        },
        mounted(){

        },

        methods: {

            showPwd() {

            },
            movePage(url) {
            },
        }
    }
</script>
